import api from '@/lib/api';
import type { InstructorHomeSummary } from '@/types/lesson.model';

// El backend aplica este `fields` a cada LessonDTO de `upcomingLessons` (no al DTO
// resumen), así que el selector debe ser de campos de LessonDTO. Las 4 métricas
// siempre se serializan completas. `timezone` es necesario para la conversión de
// fecha a la zona horaria de la clase en el facade.
const STATS_FIELDS =
  'id,sport(name),club(name),startDate,endDate,timezone,' +
  'price(value,currency(isoCode)),maxPlayerLesson,players(email)';

export const getInstructorStats = async (): Promise<InstructorHomeSummary> => {
  const response = await api.get<InstructorHomeSummary>('/lesson/me/stats', {
    params: { fields: STATS_FIELDS },
  });
  return response.data;
};
